import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import MenuCategory from "./MenuCategory";

import menu from "../../API/menu.json";
import rnfSVG from "../../images/RNF.svg";
import hadeland from "../../images/hadeland.png";
import Sparebank1SVG from "../../images/Sparebank1.svg";
import { getPlanbarometerOptions } from "../../planbarometer/PlanbarometerOptions";

import JevnakerLogo from '../../images/jevnaker-kommune-vapen.svg';
import HoleLogo from '../../images/hole-kommune-vapen.svg';
import RingerikeLogo from '../../images/ringerike-kommune-vapen.svg';










const Menu = (props) => {

    const [options, setOptions] = useState([]);

    useEffect(() => {
        getPlanbarometerOptions().then(setOptions);
    }, []);
    
    const searchFunction = () => {
        var input, filter, ul, li, a, i, txtValue;
        input = document.getElementById("searchBar");
        filter = input.value.toUpperCase();
        ul = document.getElementById("searchUl");
        li = ul.getElementsByTagName("li");
        for (i = 0; i < li.length; i++) {
            a = li[i].getElementsByTagName("a")[0];
            txtValue = a.textContent || a.innerText;
            if (filter === "") {
                li[i].style.display = "none";
            } 
            else {
                if (txtValue.toUpperCase().indexOf(filter) > -1) {
                    li[i].style.display = "";
                    } 
                else {
                        li[i].style.display = "none";
                    }
            }
        }
    }



    

    if (props.rolle !== "Alle") {
        console.log("rolle: " + props.rolle)
        // filterList = filterList.filter((roles) => roles.role_id === "1");
    }

    const logoMap = {
        Ringerike: RingerikeLogo,
        Hole: HoleLogo,
        Jevnaker: JevnakerLogo,
      };
      


    

    return (
        <div id="menuwrapper" style={{}}>
            <aside style={{ }}>
                <header id="menuheader">
                    {
                    //municipalityURL is a string!!
                    props.municipalityUrl === "1" && (
                        <>
                        {/* <img src={usnSVG} className="sponserLogo" alt="usnSVG" /> */}
                        <img src={rnfSVG} className="sponserLogo" alt="rnfSVG" />
                        <img
                            src={Sparebank1SVG}
                            className="sponserLogo"
                            alt="Sparebank1SVG"
                        />
                        </>
                    )
                    }
                    {props.municipalityUrl === "3" && (
                    <div style={{background:"",color:"black"}}>
                        <img src={hadeland} className="sponserLogo" alt="rnfSVG" />
                    </div>
                    )}
                    <input
                        style={{width:"100%"}}
                        autoComplete="off"
                        type="text"
                        id="searchBar"
                        onKeyUp={searchFunction}
                        onKeyDown={searchFunction}
                        placeholder="Search.."
                    />
                </header>
            
                <section className="menucategoryContainer" style={{ height: props.dimensions.height - 175 }}>
    {menu.site_menus.map((value) => {
        if (value.site_id.toString() === props.municipalityUrl) {
            return (
                <div key={value.name}>
                    <ul id="searchUl">
                        {value.search_indicators.map((value20) => (
                            <li style={{ display: "none" }} key={value20.indicator_id}>
                                <Link
                                    to={{
                                        pathname: "/",
                                        search:
                                            "?municipality=" + props.municipalityUrl +
                                            "&indicator=" + value20.indicator_id,
                                    }}
                                >
                                    {value20.indicator_name}
                                </Link>
                            </li>
                        ))}
                    </ul>

                    {/* First MenuRoot (Hjem only) */}
                    <section className="menuRoot">
                        <ol className="favoriteElement">
                            <Link
                                className="favoriteElementLogo"
                                to={{
                                    pathname: "/",
                                    search:
                                        "?municipality=" + props.municipalityUrl + "&indicator=0",
                                }}
                            >
                                Hjem
                            </Link>
                        </ol>
                    </section>

                    {/* NEW MenuRoot (Only for site ID 1) */}
                    {props.municipalityUrl === "1" && (
                        <section className="menuRoot newMenuRoot dropdownContainer">
                        <ol className="favoriteElement PBB-OL">
                            <span className="favoriteElementLogo plan-Title">PLANBAROMETER</span> <br></br>

                            <div className="kommunevåpen-ringeriks-planbarometer">
                            <img className="kommune-våpen-plan " src={RingerikeLogo} alt="Ringerike kommune våpen" />
                            <img className="kommune-våpen-plan" src={HoleLogo} alt="Hole kommune våpen" />
                            <img className="kommune-våpen-plan" src={JevnakerLogo} alt="Jevnaker kommune våpen" />
                        </div>
                        </ol>
                    
                    
                        
                        <ul className="dropdownMenu">
                        <li className="dropdownTitle">Planbarometer for Ringeriksregionen</li>
                        {options.map((item, index) => {
                            const logoSrc = logoMap[item.name] || null;

                            return (
                            <li key={index} > 
                                <a href={item.url} target="_blank" rel="noopener noreferrer" className="dropdownLink">
                                
                                <div className="planbarometerTitle">
                                    PLANBAROMETER
                                </div>

                                {/* New parent container for kommune name + logo */}
                                <div className="kommuneInfoContainer">
                                    <div className="kommuneName">
                                    FOR {item.name.toUpperCase()}
                                    </div>
                                    {logoSrc && (
                                    <div className="kommuneLogoContainer">
                                        <img 
                                        src={logoSrc} 
                                        alt={`${item.name} logo`} 
                                        className="kommuneLogo"
                                        />
                                    </div>
                                    )}
                                </div>

                                </a>
                            </li>
                            );
                        })}
                        </ul>




                    </section>
                    
                      
                      
                      
                    )}


                    {/* New container for everything after "Hjem" */}
                    <div className="additionalMenuContainer">
                        {value.root_menu_element.map((menuItem) => (
                            <MenuCategory key={menuItem.root_menu_name} data={menuItem} municipalityUrl={props.municipalityUrl} rolle={props.rolle} />
                        ))}
                    </div>
                </div>
            );
        }
        return null;
    })}
</section>


            </aside>
        </div>
    )
}


export default Menu;